import React, { Component } from 'react';

export class Services extends Component {
  static displayName = Services.name;

  render () {
    return (
      <div>
        <section className="hero-services container">
  <div className="text">
    <h1>हमारी पवित्र सेवाएँ</h1>
    <p>
      भक्ति, ध्यान, सेवा और वेदांत के मार्ग पर चलाते हुए हम ऐसे
      आध्यात्मिक कार्य प्रदान करते हैं जो साधकों को अपने अंतर्यामी
      स्वरूप से जोड़ते हैं और सनातन धर्म के प्रकाश को उनके जीवन में
      प्रज्ज्वलित करते हैं।
    </p>
  </div>

  <div className="image">
    <div className="aura"></div>
    <img
      src="/images/guruji_photo.jpg"
      alt="Sanatan Dharma Services"
    />
  </div>
</section>

{/* SERVICES GRID */}
<section className="services container">
  <h2>आध्यात्मिक सेवाएँ</h2>

  <div className="service-grid">

    <div className="service-card">
      <div className="service-icon">
        <i className="fas fa-praying-hands"></i>
      </div>
      <h4>दैनिक पूजा एवं आरती</h4>
      <p>
        वेद-मंत्रों के साथ सम्पन्न होने वाली नित्य पूजा, आरती तथा अनुष्ठान
        दिव्य ऊर्जा का अनुभव कराते हैं और मन को शुद्ध करते हैं।
      </p>
    </div>

    <div className="service-card">
      <div className="service-icon">
        <i className="fas fa-yin-yang"></i>
      </div>
      <h4>ध्यान एवं साधना</h4>
      <p>
        मार्गदर्शित ध्यान, मंत्र-जप और मौन साधना द्वारा साधक
        भीतर की शांति एवं साक्षीभाव को अनुभव करते हैं।
      </p>
    </div>

    <div className="service-card">
      <div className="service-icon">
        <i className="fas fa-book-open"></i>
      </div>
      <h4>वैदिक शिक्षण</h4>
      <p>
        श्रीमद्भगवद्गीता, उपनिषद्, योग-वेदांत और सनातन ग्रंथों की
        नियमित शिक्षाएँ एवं सत्संग — ज्ञान को जीवन में उतारने का मार्ग।
      </p>
    </div>

    <div className="service-card">
      <div className="service-icon">
        <i className="fas fa-hands-helping"></i>
      </div>
      <h4>सेवा एवं जनकल्याण</h4>
      <p>
        अन्नदान, वस्त्रदान, पर्यावरण सेवा, गौ-सेवा और
        जरूरतमंदों की सहायता—निःस्वार्थ कर्म का वास्तविक स्वरूप।
      </p>
    </div>

    <div className="service-card">
      <div className="service-icon">
        <i className="fas fa-dharmachakra"></i>
      </div>
      <h4>उत्सव एवं यात्राएँ</h4>
      <p>
        पवित्र पर्व, भजन-संध्या, यज्ञ, कीर्तन और भारत के तीर्थस्थलों की
        आध्यात्मिक यात्राएँ—भक्ति और संस्कृति का संगम।
      </p>
    </div>

    <div className="service-card">
      <div className="service-icon">
        <i className="fas fa-spa"></i>
      </div>
      <h4>आयुर्वेद एवं प्राकृतिक उपचार</h4>
      <p>
        प्राचीन आयुर्वेदिक ज्ञान पर आधारित स्वास्थ्य मार्गदर्शन,
        दोष-समतुलन, और प्राकृतिक उपचार। शरीर-मन की संपूर्ण समन्विति।
      </p>
    </div>
  </div>
</section>

{/* CTA */}
<section className="cta container">
  <h3>हमारे आध्यात्मिक परिवार से जुड़ें</h3>
  <p>
    शांति, भक्ति, ज्ञान और सेवा के दिव्य पथ पर साथ मिलकर चलें।  
    आइए—सनातन धर्म की अनन्त ज्योति को विश्व में फैलाएँ।
  </p>

  <button
    className="btn"
    onClick={() => (window.location.href = "/contact")}
  >
    संपर्क करें
  </button>
</section>

      </div>
    );
  }
}